var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAmbulance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.241,
    x2: 190.619,
    xlinkHref: "#lg1",
    y1: 197.769,
    y2: 292.418
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.573,
    x2: 51.948,
    xlinkHref: "#lg2",
    y1: 328.549,
    y2: 103.924
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.376,
    x2: 144.376,
    xlinkHref: "#lg3",
    y1: 118.365,
    y2: 279.58
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#d22725",
    stopOpacity: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.606,
    x2: 62.608,
    xlinkHref: "#lg4",
    y1: 203.127,
    y2: 149.876
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.124,
    x2: 150.613,
    xlinkHref: "#lg4",
    y1: 221.906,
    y2: 136.205
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.382,
    x2: 349.382,
    xlinkHref: "#lg3",
    y1: 66.305,
    y2: 122.32
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.331,
    x2: 361.081,
    xlinkHref: "#lg5",
    y1: 83.996,
    y2: 45.996
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.873,
    x2: 361.873,
    xlinkHref: "#lg5",
    y1: 58.703,
    y2: 114.718
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.145,
    x2: 343.395,
    y1: 73.956,
    y2: 26.456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.383,
    x2: 349.383,
    xlinkHref: "#lg6",
    y1: 98.698,
    y2: 127.204
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.922,
    x2: 414.638,
    xlinkHref: "#lg1",
    y1: 149.761,
    y2: 365.976
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.083,
    x2: 333.083,
    xlinkHref: "#lg1",
    y1: 276.012,
    y2: 252.99
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.966,
    x2: 373.966,
    xlinkHref: "#lg1",
    y1: 275.121,
    y2: 79.69
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.969,
    x2: 370.969,
    y1: 143.121,
    y2: 221.791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65e0db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#27d2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18cefb"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.801,
    x2: 125.801,
    xlinkHref: "#lg1",
    y1: 289.723,
    y2: 381.593
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.867,
    x2: 388.867,
    xlinkHref: "#lg1",
    y1: 289.723,
    y2: 381.593
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.877,
    x2: 498.959,
    y1: 329.109,
    y2: 357.437
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.042,
    x2: 29.123,
    xlinkHref: "#lg3",
    y1: 329.109,
    y2: 357.437
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.194,
    x2: 45.194,
    xlinkHref: "#lg1",
    y1: 368.216,
    y2: 402.383
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.806,
    x2: 464.806,
    xlinkHref: "#lg1",
    y1: 368.216,
    y2: 402.383
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.562,
    x2: 177.664,
    xlinkHref: "#lg6",
    y1: 377.115,
    y2: 445.216
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#b6b7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6581,
    stopColor: "#a097a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b788a"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.553,
    x2: 95.958,
    xlinkHref: "#lg7",
    y1: 414.106,
    y2: 363.511
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b788a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.157,
    x2: 122.755,
    xlinkHref: "#lg8",
    y1: 423.714,
    y2: 390.312
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.326,
    x2: 144.201,
    xlinkHref: "#lg6",
    y1: 385.88,
    y2: 411.754
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0471,
    stopColor: "#6e566e",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.495,
    x2: 153.953,
    xlinkHref: "#lg9",
    y1: 401.011,
    y2: 349.942
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.629,
    x2: 440.73,
    xlinkHref: "#lg6",
    y1: 377.115,
    y2: 445.216
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.619,
    x2: 359.024,
    xlinkHref: "#lg7",
    y1: 414.106,
    y2: 363.511
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.223,
    x2: 385.821,
    xlinkHref: "#lg8",
    y1: 423.714,
    y2: 390.312
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.393,
    x2: 407.267,
    xlinkHref: "#lg6",
    y1: 385.88,
    y2: 411.754
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.561,
    x2: 417.02,
    xlinkHref: "#lg9",
    y1: 401.011,
    y2: 349.942
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.054,
    x2: 257.054,
    xlinkHref: "#lg1",
    y1: 368.216,
    y2: 402.383
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.907,
    x2: 426.405,
    xlinkHref: "#lg2",
    y1: 250.907,
    y2: 318.409
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.335,
    x2: 386.668,
    xlinkHref: "#lg2",
    y1: 291.255,
    y2: 181.255
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.995,
    x2: 450.625,
    xlinkHref: "#lg6",
    y1: 222.691,
    y2: 239.237
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m297.362 391.276h-288.933v-290.808c0-9.087 7.366-16.453 16.453-16.453h256.027c9.087 0 16.453 7.366 16.453 16.453z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.362 247.041-120.552-120.551c-1.069-3.154-4.046-5.427-7.561-5.427h-49.747c-4.412 0-7.989 3.577-7.989 7.989v34.438h-34.438c-4.412 0-7.989 3.577-7.989 7.989v49.747c0 3.515 2.273 6.493 5.427 7.561l161.878 162.489h60.971z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211.676 163.49h-34.438v-34.438c0-4.412-3.577-7.989-7.989-7.989h-49.747c-4.412 0-7.989 3.577-7.989 7.989v34.438h-34.438c-4.412 0-7.989 3.577-7.989 7.989v49.747c0 4.412 3.577 7.989 7.989 7.989h34.438v34.438c0 4.412 3.577 7.989 7.989 7.989h49.747c4.412 0 7.989-3.577 7.989-7.989v-34.438h34.438c4.412 0 7.989-3.577 7.989-7.989v-49.747c0-4.412-3.577-7.989-7.989-7.989z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.676 163.49h-34.438v-34.438c0-4.412-3.577-7.989-7.989-7.989h-24.874v150.578h24.874c4.412 0 7.989-3.577 7.989-7.989v-34.438h34.438c4.412 0 7.989-3.577 7.989-7.989v-49.747c0-4.411-3.577-7.988-7.989-7.988z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.087 193.583v27.642c0 4.412 3.577 7.989 7.989 7.989h34.438v34.438c0 4.412 3.577 7.989 7.989 7.989h49.747c4.412 0 7.989-3.577 7.989-7.989v-34.438h34.438c4.412 0 7.989-3.577 7.989-7.989v-27.642z",
    fill: "url(#SVGID_5_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m380.732 110.252h-62.7v-21.124c0-17.314 14.036-31.35 31.35-31.35 17.314 0 31.35 14.036 31.35 31.35z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.734 61.255c-5.826-3.004-12.656-3.004-18.482 0-10.095 5.206-16.999 15.732-16.999 27.873v21.125h52.48v-21.125c-.001-12.142-6.904-22.667-16.999-27.873z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.383 57.778c-2.182 0-4.312.224-6.369.649 14.26 2.943 24.981 15.57 24.981 30.701v21.125h12.738v-21.125c-.001-17.314-14.036-31.35-31.35-31.35z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 349.383,
    cy: 75.915,
    fill: "url(#SVGID_9_)",
    rx: 21.894,
    ry: 15.823
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390.952 121.063h-83.139v-17.076c0-5.317 4.311-9.628 9.628-9.628h63.883c5.317 0 9.628 4.311 9.628 9.628z",
    fill: "url(#SVGID_10_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m458.39 237.646-37.438-109.193c-3.633-10.595-13.596-17.711-24.796-17.711h-88.853c-5.49 0-9.941 4.451-9.941 9.941v267.919h204.731v-127.608c0-12.895-10.453-23.349-23.349-23.349h-20.354z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.109 271.512h-28.051c-4.542 0-8.224-3.682-8.224-8.224v-2.537c0-4.542 3.682-8.224 8.224-8.224h28.051c4.542 0 8.224 3.682 8.224 8.224v2.537c0 4.541-3.682 8.224-8.224 8.224z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.507 224.304-32.673-91.666c-1.474-4.136-5.39-6.897-9.78-6.897h-85.212c-2.225 0-4.029 1.804-4.029 4.029v104.375c0 2.225 1.804 4.029 4.029 4.029h117.885c7.177-.001 12.19-7.109 9.78-13.87z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.813 213.456v-62.998c0-5.367 4.35-9.717 9.717-9.717h54.416c4.109 0 7.773 2.584 9.153 6.455l22.455 62.998c2.255 6.327-2.436 12.979-9.153 12.979h-76.87c-5.367 0-9.718-4.35-9.718-9.717z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m210.217 391.276h-168.831c1.099-48.997 38.466-88.334 84.421-88.334 45.943 0 83.311 39.337 84.41 88.334z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.288 391.276h-168.841c1.099-48.997 38.477-88.334 84.421-88.334 45.943 0 83.321 39.337 84.42 88.334z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m500.417 363.693h-20.998c-2.9 0-5.251-2.351-5.251-5.251v-31.998c0-2.9 2.351-5.251 5.251-5.251h20.998c2.9 0 5.251 2.351 5.251 5.251v31.998c0 2.9-2.351 5.251-5.251 5.251z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.581 363.693h-20.998c-2.9 0-5.251-2.351-5.251-5.251v-31.998c0-2.9 2.351-5.251 5.251-5.251h20.998c2.9 0 5.251 2.351 5.251 5.251v31.998c0 2.9-2.351 5.251-5.251 5.251z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m81.608 397.248h-72.828c-4.849 0-8.78-3.931-8.78-8.78v-24.21c0-4.849 3.931-8.78 8.78-8.78h72.828c4.849 0 8.78 3.931 8.78 8.78v24.21c0 4.849-3.931 8.78-8.78 8.78z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.22 397.248h-72.828c-4.849 0-8.78-3.931-8.78-8.78v-24.21c0-4.849 3.931-8.78 8.78-8.78h72.828c4.849 0 8.78 3.931 8.78 8.78v24.21c0 4.849-3.931 8.78-8.78 8.78z",
    fill: "url(#SVGID_20_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m184.677 393.36c0 8.987-2.018 17.495-5.615 25.114-5.827 12.331-15.816 22.32-28.161 28.133-7.604 3.612-16.126 5.615-25.099 5.615-32.521 0-58.876-26.355-58.876-58.862 0-32.521 26.355-58.876 58.876-58.876s58.875 26.355 58.875 58.876z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.801,
    cy: 393.355,
    fill: "url(#SVGID_22_)",
    r: 29.986
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.062 418.474c-5.827 12.331-15.816 22.32-28.161 28.133l-38.079-38.079c-4.275-3.668-6.998-9.1-6.998-15.167 0-11.033 8.945-19.978 19.978-19.978 6.081 0 11.513 2.723 15.181 7.012z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.801,
    cy: 393.355,
    fill: "url(#SVGID_24_)",
    rx: 19.979,
    ry: 19.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.739 375.486c1.348 2.689 2.107 5.723 2.107 8.936 0 11.032-8.945 19.975-19.98 19.975-3.213 0-6.248-.759-8.937-2.107 3.28 6.546 10.051 11.04 17.872 11.04 11.034 0 19.979-8.943 19.979-19.976.001-7.819-4.494-14.588-11.041-17.868z",
    fill: "url(#SVGID_25_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m447.744 393.36c0 8.987-2.018 17.495-5.615 25.114-5.827 12.331-15.816 22.32-28.161 28.133-7.604 3.612-16.126 5.615-25.099 5.615-32.521 0-58.876-26.355-58.876-58.862 0-32.521 26.355-58.876 58.876-58.876s58.875 26.355 58.875 58.876z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.868,
    cy: 393.355,
    fill: "url(#SVGID_27_)",
    r: 29.986
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.128 418.474c-5.827 12.331-15.816 22.32-28.161 28.133l-38.079-38.079c-4.275-3.668-6.998-9.1-6.998-15.167 0-11.033 8.945-19.978 19.978-19.978 6.081 0 11.513 2.723 15.181 7.012z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.868,
    cy: 393.355,
    fill: "url(#SVGID_29_)",
    rx: 19.979,
    ry: 19.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.805 375.486c1.348 2.689 2.107 5.723 2.107 8.936 0 11.032-8.945 19.975-19.98 19.975-3.213 0-6.248-.759-8.937-2.107 3.28 6.546 10.051 11.04 17.872 11.04 11.034 0 19.979-8.943 19.979-19.976.001-7.819-4.494-14.588-11.041-17.868z",
    fill: "url(#SVGID_30_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m311.366 397.248h-108.623c-5.808 0-10.516-4.708-10.516-10.516v-20.739c0-5.808 4.708-10.516 10.516-10.516h108.623c5.808 0 10.516 4.708 10.516 10.516v20.739c0 5.808-4.708 10.516-10.516 10.516z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.093 291.5v-30.506c0-12.895-10.453-23.349-23.349-23.349h-20.354v40.58c0 7.331 5.943 13.275 13.275 13.275z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.093 260.994c0-12.895-10.453-23.349-23.349-23.349h-20.354l-8.696-25.363c-3.971-2.829-8.599-4.187-12.883-4.187-2.619 0-4.735 2.126-4.735 4.735v34.892c0 2.095 1.376 3.862 3.266 4.478l66.75 66.75v-57.956z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436.811 252.461c-2.617 0-4.739-2.122-4.739-4.739v-34.886c0-2.617 2.122-4.739 4.739-4.739 12.251 0 22.182 9.931 22.182 22.182 0 12.25-9.931 22.182-22.182 22.182z",
    fill: "url(#SVGID_34_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAmbulance);
export default __webpack_public_path__ + "static/media/icon-ambulance.364a2469ee9eea7fc7abe1ff317489c2.svg";
export { ForwardRef as ReactComponent };